import apiClient from './client';

export const dealsApi = {
  getDeals: async (params = {}) => {
    const response = await apiClient.get('/api/v1/deals', { params });
    return response.data;
  },

  getDealsFull: async (params = {}) => {
    const response = await apiClient.get('/api/v1/deals/full', { params });
    return response.data;
  },
};
